module.exports = __webpack_public_path__ + "media/images/flag-uk-247fe2892f4727b5d6dbc554cdc0aaa6.svg";